import React from 'react';
import PropTypes from 'prop-types';
import { withPolaris } from 'Components/protons/Polaris';

import { HtmlSafe } from 'polaris-coreweb/exports';
import { Heading } from 'Components/molecules/Heading';
import { RegPlateForm } from 'Components/molecules/RegPlateForm';

import './_style.scss';

const ValuationHeader = ({
  context: {
    cssPrefix,
    regPlateFormConfig: {
      valuationHeader: {
        regPlateFormProps: {
          inputPlaceholder,
          trackingData,
        },
      },
    },
    login: {
      smc: {
        signInWithTagline,
      },
    },
  },
  data: {
    title,
    bodyHtml,
    ctaLink: {
      title: ctaTitle,
      url: ctaUrl,
    },
    passParams,
  },
}) => (
  <div className={`${cssPrefix}__valuationheader`}>
    <div className={`${cssPrefix}__valuationheader--container`}>
      <Heading
        size={1}
        extraClassNames={{ [`${cssPrefix}__valuationheader--heading`]: true }}
      >
        {title}
      </Heading>
      <div className={`${cssPrefix}__valuationheader--desc`}>
        <HtmlSafe html={bodyHtml} />
      </div>
      <RegPlateForm
        ctaLabel={ctaTitle}
        ctaUrl={ctaUrl}
        inputPlaceholder={inputPlaceholder}
        submitTypeIsButton
        trackingData={trackingData}
        passParams={passParams}
      />
      <div className={`${cssPrefix}__valuationheader--login`}>
        <HtmlSafe html={signInWithTagline} />
      </div>
    </div>
    <div className={`${cssPrefix}__valuationheader--icon`} />
  </div>
);

ValuationHeader.propTypes = {
  context: PropTypes.shape({
    cssPrefix: PropTypes.string,
    regPlateFormConfig: PropTypes.shape({
      valuationHeader: PropTypes.shape({
        ctaUrl: PropTypes.string,
        regPlateFormProps: PropTypes.shape({
          inputPlaceholder: PropTypes.string,
          trackingData: PropTypes.shape(),
        }),
      }),
    }),
    login: PropTypes.shape({
      smc: PropTypes.shape({
        signInWithTagline: PropTypes.string,
      }),
    }),
  }),
  data: PropTypes.shape({
    title: PropTypes.string,
    bodyHtml: PropTypes.string,
    ctaLink: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }),
    passParams: PropTypes.bool,
  }).isRequired,
};

ValuationHeader.defaultProps = {
  context: {
    cssPrefix: 'polaris',
    regPlateFormConfig: {
      valuationHeader: {
        ctaUrl: '',
        regPlateFormProps: {
          inputPlaceholder: '',
          trackingData: {},
        },
      },
    },
    login: {
      smc: {
        signInWithTagline: '',
      },
    },
  },
};

export default withPolaris(ValuationHeader);
